// src/app/app.routes.ts

import { Routes } from '@angular/router';
import { authGuard } from './core/guard/auth.guard';
import { RoleGuard } from './core/guards/role.guard';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { NotFoundComponent } from './common/not-found/not-found.component';
import {authInitializerResolver} from "./core/auth/auth-initializer.resolver";


export const routes: Routes = [
    {
        path: '',
        redirectTo: 'authentication/sign-in',
        pathMatch: 'full',
    },
    {
        path: 'authentication',
        // Carga perezosa de las rutas de autenticación
        loadChildren: () => import('./authentication/authentication.routes').then(m => m.AUTH_ROUTES)
    },
    {
        path: '',
        component: MainLayoutComponent,
        resolve: { auth: authInitializerResolver },
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                loadComponent: () => import('./dashboard/ecommerce/ecommerce.component').then(m => m.EcommerceComponent)
            },
            {
                path: 'user',
                loadChildren: () => import('./dashboard/user/user.routes').then(m => m.USER_ROUTES)
            },
            {
                path: 'driver',
                loadChildren: () => import('./dashboard/driver/driver.routes').then(m => m.DRIVER_ROUTES)
            },
            {
                path: 'client',
                loadChildren: () => import('./dashboard/client/client.routes').then(m => m.CLIENT_ROUTES)
            },

            {
                path: 'freight',
                loadChildren: () => import('./dashboard/freight/freight.routes').then(m => m.FREIGHT_ROUTES)
            },
            {
                path: 'invoice',
                loadChildren: () => import('./dashboard/invoice/invoice.routes').then(m => m.INVOICE_ROUTES)
            }
        ]
    },
    { path: '**', component: NotFoundComponent }
];
